import { useRef, useState, type ComponentClass } from 'react';
import Draggable, { DraggableProps } from 'react-draggable';
import { useStyles } from './styles';
import { Box, Tab, Typography } from '@mui/material';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import ConfigTab from './ConfigTab/ConfigTab';
import MessagesTab from './MessagesTab';
import PixelStreamingTab from './PixelStreamingTab';

export enum DevelopersTerminalTabs {
  Config = 'CONFIG',
  Messages = 'MESSAGES',
  PixelStreaming = 'PIXEL_STREAMING',
}

// react-draggable types every prop as required because its defaultProps are
// not inferred as optional under React 18 types. Cast so only the props we
// actually pass are required.
const DraggableBox = Draggable as ComponentClass<Partial<DraggableProps>>;

const DevelopersTerminal = () => {
  const nodeRef = useRef<HTMLDivElement>(null);
  const [tabValue, setTabValue] = useState(DevelopersTerminalTabs.Config);
  const classes = useStyles();

  return (
    <DraggableBox
      nodeRef={nodeRef}
      cancel=".no-drag"
      defaultPosition={{ x: 100, y: 200 }}
      scale={1}
    >
      <Box ref={nodeRef} sx={classes.root}>
        <TabContext value={tabValue}>
          <Box sx={{ width: '100%' }}>
            <TabList onChange={(_, value) => setTabValue(value)}>
              <Tab
                value={DevelopersTerminalTabs.Config}
                label={<Typography>Config</Typography>}
              />
              <Tab
                value={DevelopersTerminalTabs.Messages}
                label={<Typography>Messages</Typography>}
              />
              <Tab
                value={DevelopersTerminalTabs.PixelStreaming}
                label={<Typography>Pixel Streaming</Typography>}
              />
            </TabList>
            <TabPanel value={DevelopersTerminalTabs.Config}>
              <ConfigTab />
            </TabPanel>
            <TabPanel value={DevelopersTerminalTabs.Messages}>
              <MessagesTab />
            </TabPanel>
            <TabPanel value={DevelopersTerminalTabs.PixelStreaming}>
              <PixelStreamingTab />
            </TabPanel>
          </Box>
        </TabContext>
      </Box>
    </DraggableBox>
  );
};

export default DevelopersTerminal;
